export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["nombre"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nom"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Annuler"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sauvegarder"])}
}